// src/components/Seo.jsx
import { useEffect } from "react";

/**
 * Lightweight SEO helper without extra libraries.
 * Usage: <Seo title="Page Title" description="Short meta description here." />
 */
export default function Seo({ title, description }) {
  useEffect(() => {
    // Set the document title
    if (title) {
      document.title = title;
    }

    // Set or create the meta description tag
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }
  }, [title, description]);

  return null; // This component doesn't render anything visually
}
